import { render, staticRenderFns } from "./projectHistoryTab.vue?vue&type=template&id=40721caa&scoped=true&"
import script from "./projectHistoryTab.vue?vue&type=script&lang=js&"
export * from "./projectHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./projectHistoryTab.vue?vue&type=style&index=0&id=40721caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40721caa",
  null
  
)

export default component.exports